/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Collections_Table_PositionInputs */

const id_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posisi`)
};

const ms_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedudukan`)
};

const da_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const de_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const en_us2_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const es_es2_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición`)
};

const es_mx2_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición`)
};

const fil_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posisyon`)
};

const fr_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const it_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione`)
};

const hu_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozíció`)
};

const nl_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positie`)
};

const no_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posisjon`)
};

const pl_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozycja`)
};

const pt_br2_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição`)
};

const pt_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição`)
};

const ro_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poziție`)
};

const fi_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sijoitus`)
};

const sv_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const vi_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí`)
};

const tr_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozisyon`)
};

const cs_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozice`)
};

const bg_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция`)
};

const ru_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция`)
};

const uk_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиція`)
};

const ar_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المركز`)
};

const hi_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थान`)
};

const th_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตำแหน่ง`)
};

const ja_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順位`)
};

const zh_cn2_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排名`)
};

const zh_hant1_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排名`)
};

const ko_collections_table_position = /** @type {(inputs: Collections_Table_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`순위`)
};

/**
* | output |
* | --- |
* | "Position" |
*
* @param {Collections_Table_PositionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_table_position = /** @type {((inputs?: Collections_Table_PositionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Table_PositionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_table_position(inputs)
	if (locale === "ms") return ms_collections_table_position(inputs)
	if (locale === "da") return da_collections_table_position(inputs)
	if (locale === "de") return de_collections_table_position(inputs)
	if (locale === "en-US") return en_us2_collections_table_position(inputs)
	if (locale === "es-ES") return es_es2_collections_table_position(inputs)
	if (locale === "es-MX") return es_mx2_collections_table_position(inputs)
	if (locale === "fil") return fil_collections_table_position(inputs)
	if (locale === "fr") return fr_collections_table_position(inputs)
	if (locale === "it") return it_collections_table_position(inputs)
	if (locale === "hu") return hu_collections_table_position(inputs)
	if (locale === "nl") return nl_collections_table_position(inputs)
	if (locale === "no") return no_collections_table_position(inputs)
	if (locale === "pl") return pl_collections_table_position(inputs)
	if (locale === "pt-BR") return pt_br2_collections_table_position(inputs)
	if (locale === "pt") return pt_collections_table_position(inputs)
	if (locale === "ro") return ro_collections_table_position(inputs)
	if (locale === "fi") return fi_collections_table_position(inputs)
	if (locale === "sv") return sv_collections_table_position(inputs)
	if (locale === "vi") return vi_collections_table_position(inputs)
	if (locale === "tr") return tr_collections_table_position(inputs)
	if (locale === "cs") return cs_collections_table_position(inputs)
	if (locale === "bg") return bg_collections_table_position(inputs)
	if (locale === "ru") return ru_collections_table_position(inputs)
	if (locale === "uk") return uk_collections_table_position(inputs)
	if (locale === "ar") return ar_collections_table_position(inputs)
	if (locale === "hi") return hi_collections_table_position(inputs)
	if (locale === "th") return th_collections_table_position(inputs)
	if (locale === "ja") return ja_collections_table_position(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_table_position(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_table_position(inputs)
	return ko_collections_table_position(inputs)
});
export { collections_table_position as "collections.table.position" }